<template>
  <div id="app" class="container">
    <div class="sidebar-page">
      <section class="sidebar-layout">
        <b-sidebar
          position="static"
          :mobile="mobile"
          :expand-on-hover="expandOnHover"
          :reduce="reduce"
          type="is-light"
          open
        >
          <div class="p-1">
            <b-menu class="is-custom-mobile">
              <b-menu-list label="Menu">
                <b-menu-item @click="routerHome" label="Home"></b-menu-item>
                <b-menu-item @click="routerOrder" label="pedidos"></b-menu-item>
              </b-menu-list>

              <b-menu-list label="Actions">
                <b-menu-item icon="logout" label="Logout"></b-menu-item>
              </b-menu-list>
            </b-menu>
          </div>
        </b-sidebar>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    expandOnHover: false,
    mobile: "reduce",
    reduce: false,
  }),
  methods: {
    // ...mapActions("auth", ["login"]),

    routerHome() {
      this.$router.push("/home");
    },
    routerOrder() {
      this.$router.push("/order");
    },
  },
};
</script>
<style lang="scss">
.hero.is-fullheight-with-navbar .hero-body {
  align-items: initial;
}
.p-1 {
  padding: 1em;
}
.sidebar-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  .sidebar-layout {
    display: flex;
    flex-direction: row;
    min-height: 100%;
  }
}
@media screen and (max-width: 1023px) {
  .b-sidebar {
    .sidebar-content {
      &.is-mini-mobile {
        &:not(.is-mini-expand),
        &.is-mini-expand:not(:hover) {
          .menu-list {
            li {
              a {
                span:nth-child(2) {
                  display: none;
                }
              }
              ul {
                padding-left: 0;
                li {
                  a {
                    display: inline-block;
                  }
                }
              }
            }
          }
          .menu-label:not(:last-child) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .b-sidebar {
    .sidebar-content {
      &.is-mini {
        &:not(.is-mini-expand),
        &.is-mini-expand:not(:hover) {
          .menu-list {
            li {
              a {
                span:nth-child(2) {
                  display: none;
                }
              }
              ul {
                padding-left: 0;
                li {
                  a {
                    display: inline-block;
                  }
                }
              }
            }
          }
          .menu-label:not(:last-child) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
